'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const GeocodedStatus=require('pulsar-driveplan/dist-es6/domain/geocodedStatus');
const ForecastPersonViewModel=require('../../../../dist-es6/client/viewModels/forecastPersonViewModel');let

CurrentDutyStatusDirective=function(_BaseControllerBacked){_inherits(CurrentDutyStatusDirective,_BaseControllerBacked);function CurrentDutyStatusDirective(){_classCallCheck(this,CurrentDutyStatusDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(CurrentDutyStatusDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/currentDutyStatusDirective/currentDutyStatusTemplate'}},{key:'controller',get:function()
{return CurrentDutyStatusDirectiveController}},{key:'objectBindings',get:function()
{return['personViewModel']}},{key:'$inject',get:function()
{return[]}}]);return CurrentDutyStatusDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
fullName:'Unknown',
highlight:!1,
abbreviation:'N/A'};


const HOSStatusDataMap=new Map([
[GeocodedStatus.Statuses.Driving,{
abbreviation:'D',
fullName:'Driving',
highlight:!0}],

[GeocodedStatus.Statuses.OnDuty,{
abbreviation:'ON',
fullName:'On Duty',
highlight:!0}],

[GeocodedStatus.Statuses.OffDuty,{
abbreviation:'OFF',
fullName:'Off Duty',
highlight:!1}],

[GeocodedStatus.Statuses.SleeperBerth,{
abbreviation:'SL',
fullName:'Sleeper Berth',
highlight:!1}],

[GeocodedStatus.Statuses.DrivingOffDuty,{
abbreviation:'OFF',
fullName:'Driving Off Duty',
highlight:!1}]]);let



CurrentDutyStatusDirectiveController=function(){
function CurrentDutyStatusDirectiveController($scope){var _this2=this;_classCallCheck(this,CurrentDutyStatusDirectiveController);
_.defaults(this,ControllerDefaults);

$scope.$watch('controller.personViewModel',function(){return _this2._updateVisibleStatus()});

this._updateVisibleStatus();
}CurrentDutyStatusDirectiveController.prototype.

_updateVisibleStatus=function _updateVisibleStatus(){
const result=tryGet(this,'personViewModel.currentHosStatus.value.status').
then(function(status){return HOSStatusDataMap.get(status)}).
otherwise(this.personViewModel?_getHosStatusFromCurrentStatus(this.personViewModel):ControllerDefaults);

_.assign(this,result);
};return CurrentDutyStatusDirectiveController}();


const _getHosStatusFromCurrentStatus=function(viewModel){
if(viewModel.currentStatus.onTrip){
return HOSStatusDataMap.get(GeocodedStatus.Statuses.Driving);
}

if(viewModel.currentStatus.onDuty){
return HOSStatusDataMap.get(GeocodedStatus.Statuses.OnDuty);
}

return HOSStatusDataMap.get(GeocodedStatus.Statuses.OffDuty);
};

module.exports=CurrentDutyStatusDirective;
//# sourceMappingURL=currentDutyStatusDirective.js.map
